import { Box } from '@mui/material'
import React from 'react'
import { Table } from 'reactstrap'

function UsersList() {
  return (
    <div>
      <Box>
        <h4>Users List</h4>
      <Table>
            <thead>
              <tr>
                <td>Sl</td>
                <td>Name</td>
                <td>Email </td>
                <td>Contact</td>
                <td>Action</td>
              </tr>
            </thead>
            <tbody>
              
            </tbody>
          </Table>
      </Box>
    </div>
  )
}

export default UsersList